import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';

import { withStyles } from '@material-ui/core/styles';

import { editClientForm } from '../../../store/actions';
import {
  helpDispatch,
  Tooltip,
  TooltipTypes
} from 'components/admin/Help';

const styles = theme => ({
  card: {
    marginTop: theme.spacing.unit*3,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  email: {
    flexGrow: 1,
  },
  marginRight: {
    marginRight: theme.spacing.unit*2,
  },
  marginLeft: {
    marginLeft: theme.spacing.unit*2,
  },
  marginBottom: {
    marginBottom: theme.spacing.unit*2,
  },
});

const ClientForm = ({ classes, client, editClientForm }) => {
  const { validation } = client;

  return (
    <Card className={classes.card}>
      <CardContent className={classes.content}>
        <div className={classes.marginBottom}>
          <TextField
            className={classes.marginRight}
            error={!!validation.validateField("firstName")}
            helperText={validation.validateField("firstName")}
            label="First Name"
            margin="none"
            value={client && client.firstName}
            onChange={(event) => editClientForm({firstName: event.target.value})}
          />
          <TextField
            className={classes.marginLeft}
            error={!!validation.validateField("lastName")}
            helperText={validation.validateField("lastName")}
            label="Last Name"
            margin="none"
            value={client && client.lastName}
            onChange={(event) => editClientForm({lastName: event.target.value})}
          />
        </div>
        <div className={classes.marginBottom}>
          <TextField
            className={classes.marginRight}
            label="Home Phone"
            margin="none"
            value={client.homePhone}
            onChange={(event) => editClientForm({homePhone: event.target.value})}
          />
          <TextField
            className={classes.marginLeft}
            label="Mobile Phone"
            margin="none"
            value={client.mobilePhone}
            onChange={(event) => editClientForm({mobilePhone: event.target.value})}
          />
        </div>
        <Tooltip type={TooltipTypes.clientDialog.OPTIONAL_EMAIL} placement="left">
          <TextField
            className={classes.marginBottom}
            error={!!validation.validateField("email")}
            helperText={validation.validateField("email")}
            label="Email"
            margin="none"
            value={client.email}
            onChange={(event) => editClientForm({email: event.target.value})}
          />
        </Tooltip>
        <div className={classes.marginBottom}>
          <TextField
            className={classes.marginRight}
            label="City"
            margin="none"
            value={client.city}
            onChange={(event) => editClientForm({city: event.target.value})}
          />
          <TextField
            className={classes.marginLeft}
            label="Province"
            margin="none"
            value={client.province}
            onChange={(event) => editClientForm({province: event.target.value})}
          />
        </div>
        <div className={classes.marginBottom}>
          <TextField
            className={classes.marginRight}
            label="Country"
            margin="none"
            value={client.country}
            onChange={(event) => editClientForm({country: event.target.value})}
          />
          <TextField
            className={classes.marginLeft}
            label="Postal Code"
            margin="none"
            value={client.postalCode}
            onChange={(event) => editClientForm({postalCode: event.target.value})}
          />
        </div>
        <TextField
          className={classes.marginBottom}
          label="Address"
          margin="none"
          value={client.address}
          onChange={(event) => editClientForm({address: event.target.value})}
        />
      </CardContent>
    </Card>
  );
}

const mapStateToProps = (state) => ({
  client: state.formData.client,
});

const mapDispatchToProps = {
  editClientForm,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(ClientForm);



// WEBPACK FOOTER //
// ./src/components/admin/Clients/ClientForm.jsx